import { useTypeSelector } from '../../../../store';
import {
    selectGetCatalogCategoryLoader,
    selectSelectedCategory,
} from '../../../../selectors/catalog';
import { createLoadHoc } from '../../../../helpers/hocs/createLoadHoc';
import { FaqSectionContent } from '../../../../components/Faq';

const FaqCategoryContent = () => {
    const selectedCategory = useTypeSelector(selectSelectedCategory);

    return (
        <FaqSectionContent
            title="FAQ категории"
            subtitle={selectedCategory?.name || ''}
            entityId={selectedCategory?.id}
            filterKey="categoryId"
        />
    );
};

const loader = createLoadHoc({
    selectLoader: selectGetCatalogCategoryLoader,
});

const FaqCategory = loader(FaqCategoryContent);

export default FaqCategory;
